import { Field, useFormikContext } from 'formik';

const Invoice = () => {
    const { values, setFieldValue } = useFormikContext();

    return (
        <>
            <div className='flex items-center my-5'>
                <span className='w-1/2 h-0.5 border border-dashed inline-block'></span>
                <p className='px-4 text-sm shrink-0 w-fit'>Invoice & Items</p>
                <span className='w-1/2 h-0.5 border border-dashed inline-block'></span>
            </div>
            <div className='flex flex-wrap items-start gap-5 lg:flex-nowrap'>
                <div className='w-full '>
                    <div className="space-y-8">
                        <div className="flex items-center">
                            <span className="w-12 h-0.5 bg-border inline-block mr-2"></span>
                            <p className="text-sm">Invoice Information</p>
                        </div>

                        <div className="grid grid-cols-1 gap-6 md:grid-cols-2 lg:grid-cols-4">
                            {/* Invoice Number */}
                            {/* <div>
                                <label className="mb-1 form-label">Invoice Number Label</label>
                                <Field className="input" type="text" name="invoice_template_settings.invoice.invoice_number_label" />
                                <Field name="invoice_template_settings.invoice.show_invoice_number">
                                    {({ field, form }) => (
                                        <label className="mt-2 switch w-fit">
                                            <span className="switch-label">Show Invoice Number</span>
                                            <input
                                                type="checkbox"
                                                checked={field.value}
                                                onChange={() => setFieldValue("invoice_template_settings.invoice.show_invoice_number", !field.value)}
                                            />
                                        </label>
                                    )}
                                </Field>
                            </div> */}

                            {/* Due Date */}
                            <div>
                                <label className="mb-1 form-label">Due Date Label</label>
                                <Field className="input" type="text" name="invoice_template_settings.invoice.due_date_label" />
                                <Field name="invoice_template_settings.invoice.show_due_date">
                                    {({ field, form }) => (
                                        <label className="mt-2 switch w-fit">
                                            <span className="switch-label">Show Due Date</span>
                                            <input
                                                type="checkbox"
                                                checked={field.value}
                                                onChange={() => setFieldValue("invoice_template_settings.invoice.show_due_date", !field.value)}
                                            />
                                        </label>
                                    )}
                                </Field>
                            </div>

                            {/* Issue Date */}
                            <div>
                                <label className="mb-1 form-label">Issue Date Label</label>
                                <Field className="input" type="text" name="invoice_template_settings.invoice.issue_date_label" />
                                {/* <Field name="invoice_template_settings.invoice.show_issue_date">
                            {({ field, form }) => (
                            <label className="mt-2 switch w-fit">
                                <span className="switch-label">Show Issue Date</span>
                                <input
                                type="checkbox"
                                checked={field.value}
                                onChange={() => setFieldValue("invoice_template_settings.invoice.show_issue_date", !field.value)}
                                />
                            </label>
                            )}
                        </Field> */}
                            </div>

                            {/* Invoice Title */}
                            <div>
                                <label className="mb-1 form-label">Invoice Title Label</label>
                                <Field className="input" type="text" name="invoice_template_settings.invoice.title_label" />
                                <Field name="invoice_template_settings.invoice.show_title">
                                    {({ field, form }) => (
                                        <label className="mt-2 switch w-fit">
                                            <span className="switch-label">Show Invoice Title</span>
                                            <input
                                                type="checkbox"
                                                checked={field.value}
                                                onChange={() => setFieldValue("invoice_template_settings.invoice.show_title", !field.value)}
                                            />
                                        </label>
                                    )}
                                </Field>
                            </div>

                            {/* Terms & Conditions */}
                            <div className="">
                                <label className="mb-1 form-label">Terms & Conditions Label</label>
                                <Field className="input" type="text" name="invoice_template_settings.invoice.terms_conditions_label" />
                                <Field name="invoice_template_settings.invoice.show_terms_conditions">
                                    {({ field, form }) => (
                                        <label className="mt-2 switch w-fit">
                                            <span className="switch-label">Show Terms & Conditions</span>
                                            <input
                                                type="checkbox"
                                                checked={field.value}
                                                onChange={() =>
                                                    setFieldValue("invoice_template_settings.invoice.show_terms_conditions", !field.value)
                                                }
                                            />
                                        </label>
                                    )}
                                </Field>
                            </div>
                            <div className="">
                                <label className="mb-1 form-label">Note Label</label>
                                <Field className="input" type="text" name="invoice_template_settings.invoice.note_label" />
                                <Field name="invoice_template_settings.invoice.show_note">
                                    {({ field, form }) => (
                                        <label className="mt-2 switch w-fit">
                                            <span className="switch-label">Show Note</span>
                                            <input
                                                type="checkbox"
                                                checked={field.value}
                                                onChange={() =>
                                                    setFieldValue("invoice_template_settings.invoice.show_note", !field.value)
                                                }
                                            />
                                        </label>
                                    )}
                                </Field>
                            </div>
                            {/* <div className="">
                        <label className="mb-1 form-label">Reference Number Label</label>
                        <Field className="input" type="text" name="invoice_template_settings.invoice.reference_number_label" />
                        <Field name="invoice_template_settings.invoice.show_reference_number">
                            {({ field, form }) => (
                            <label className="mt-2 switch w-fit">
                                <span className="switch-label">Show Reference Number</span>
                                <input
                                type="checkbox"
                                checked={field.value}
                                onChange={() =>
                                    setFieldValue("invoice_template_settings.invoice.show_reference_number", !field.value)
                                }
                                />
                            </label>
                            )}
                        </Field>
                        </div> */}
                        </div>
                    </div>
                    <div className="space-y-8">
                        <div className="flex items-center mt-8">
                            <span className="w-12 h-0.5 bg-border inline-block mr-2"></span>
                            <p className="text-sm">Items Information</p>
                        </div>

                        <div className="grid grid-cols-1 gap-6 md:grid-cols-2 lg:grid-cols-4">
                            {/* Invoice Number */}
                            <div>
                                <label className="mb-1 form-label">Date Label</label>
                                <Field className="input" type="text" name="invoice_template_settings.time_entries.date_label" />
                                {/* <Field name="invoice_template_settings.time_entries.show_date">
                            {({ field, form }) => (
                            <label className="mt-2 switch w-fit">
                                <span className="switch-label">Show Date label</span>
                                <input
                                type="checkbox"
                                checked={field.value}
                                onChange={() => setFieldValue("invoice_template_settings.time_entries.show_date", !field.value)}
                                />
                            </label>
                            )}
                        </Field> */}
                            </div>

                            {/* Due Date */}
                            <div>
                                <label className="mb-1 form-label">Hours Label</label>
                                <Field className="input" type="text" name="invoice_template_settings.time_entries.hours_label" />
                                {/* <Field name="invoice_template_settings.time_entries.show_hours">
                            {({ field, form }) => (
                            <label className="mt-2 switch w-fit">
                                <span className="switch-label">Show Hours</span>
                                <input
                                type="checkbox"
                                checked={field.value}
                                onChange={() => setFieldValue("invoice_template_settings.time_entries.show_hours", !field.value)}
                                />
                            </label>
                            )}
                        </Field> */}
                            </div>

                            {/* Issue Date */}
                            <div>
                                <label className="mb-1 form-label">Item Label</label>
                                <Field className="input" type="text" name="invoice_template_settings.time_entries.time_entries_label" />
                                {/* <Field name="invoice_template_settings.time_entries.show_items">
                            {({ field, form }) => (
                            <label className="mt-2 switch w-fit">
                                <span className="switch-label">Show Item</span>
                                <input
                                type="checkbox"
                                checked={field.value}
                                onChange={() => setFieldValue("invoice_template_settings.time_entries.show_items", !field.value)}
                                />
                            </label>
                            )}
                        </Field> */}
                            </div>

                            {/* Invoice Title */}
                            <div>
                                <label className="mb-1 form-label">Rate Label</label>
                                <Field className="input" type="text" name="invoice_template_settings.time_entries.rate_label" />
                                {/* <Field name="invoice_template_settings.time_entries.show_rate">
                            {({ field, form }) => (
                            <label className="mt-2 switch w-fit">
                                <span className="switch-label">Show Rate</span>
                                <input
                                type="checkbox"
                                checked={field.value}
                                onChange={() => setFieldValue("invoice_template_settings.time_entries.show_rate", !field.value)}
                                />
                            </label>
                            )}
                        </Field> */}
                            </div>

                            {/* Terms & Conditions */}
                            <div className="">
                                <label className="mb-1 form-label">Subtotal Label</label>
                                <Field className="input" type="text" name="invoice_template_settings.time_entries.subtotal_label" />
                            </div>

                            {/* Terms & Conditions */}
                            <div className="">
                                <label className="mb-1 form-label">Billed By Label</label>
                                <Field className="input" type="text" name="invoice_template_settings.time_entries.billed_by_label" />
                                {/* <Field name="invoice_template_settings.time_entries.show_billed_by">
                            {({ field, form }) => (
                            <label className="mt-2 switch w-fit">
                                <span className="switch-label">Show Billed By</span>
                                <input
                                type="checkbox"
                                checked={field.value}
                                onChange={() =>
                                    setFieldValue("invoice_template_settings.time_entries.show_billed_by", !field.value)
                                }
                                />
                            </label>
                            )}
                        </Field> */}
                            </div>
                            <div className="">
                                <label className="mb-1 form-label">Description Label</label>
                                <Field className="input" type="text" name="invoice_template_settings.time_entries.description_label" />
                                {/* <Field name="invoice_template_settings.time_entries.show_description">
                            {({ field, form }) => (
                            <label className="mt-2 switch w-fit">
                                <span className="switch-label">Show Description</span>
                                <input
                                type="checkbox"
                                checked={field.value}
                                onChange={() =>
                                    setFieldValue("invoice_template_settings.time_entries.show_description", !field.value)
                                }
                                />
                            </label>
                            )}
                        </Field> */}
                            </div>
                            <div className="">
                                <label className="mb-1 form-label">Tax Label</label>
                                <Field className="input" type="text" name="invoice_template_settings.time_entries.tax_label" />
                            </div>
                            {/* <div className="">
                            <label className="mb-1 form-label">Tax 2 Label</label>
                            <Field className="input" type="text" name="invoice_template_settings.time_entries.tax2_label" />
                        </div> */}
                            <div className="">
                                <label className="mb-1 form-label">Total Label</label>
                                <Field className="input" type="text" name="invoice_template_settings.time_entries.total_label" />
                                {/* <Field name="invoice_template_settings.time_entries.show_total">
                            {({ field, form }) => (
                            <label className="mt-2 switch w-fit">
                                <span className="switch-label">Show Total</span>
                                <input
                                type="checkbox"
                                checked={field.value}
                                onChange={() =>
                                    setFieldValue("invoice_template_settings.time_entries.show_total", !field.value)
                                }
                                />
                            </label>
                            )}
                        </Field> */}
                            </div>
                        </div>
                        {/* <div className="">
                        <Field name="invoice_template_settings.time_entries.use_initials_for_billed_by">
                            {({ field, form }) => (
                            <label className="mt-2 switch w-fit">
                                <span className="switch-label">Show billed by initials instead of full name?</span>
                                <input
                                type="checkbox"
                                checked={field.value}
                                onChange={() =>
                                    setFieldValue("invoice_template_settings.time_entries.use_initials_for_billed_by", !field.value)
                                }
                                />
                            </label>
                            )}
                        </Field>
                        <Field name="invoice_template_settings.time_entries.show_summary">
                            {({ field, form }) => (
                            <label className="mt-2 switch w-fit">
                                <span className="switch-label">Show Summary</span>
                                <input
                                type="checkbox"
                                checked={field.value}
                                onChange={() =>
                                    setFieldValue("invoice_template_settings.time_entries.show_summary", !field.value)
                                }
                                />
                            </label>
                            )}
                        </Field>
                        <Field name="invoice_template_settings.time_entries.group_summary_by_user">
                            {({ field, form }) => (
                            <label className="mt-2 switch w-fit">
                                <span className="switch-label">Show summary by user?</span>
                                <input
                                type="checkbox"
                                checked={field.value}
                                onChange={() =>
                                    setFieldValue("invoice_template_settings.time_entries.group_summary_by_user", !field.value)
                                }
                                />
                            </label>
                            )}
                        </Field>
                    </div> */}
                    </div>
                </div>
            </div>
        </>
    )
}

export { Invoice }